import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { forwardRef, inject, NgModule, provideAppInitializer, Provider } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicModule, ModalController } from '@ionic/angular/lazy';
import { IonicStorageModule, Storage } from '@ionic/storage-angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EventService } from './services/event.service';
import { ApiModule } from './api/api.module';
import { ApiService } from './api/services';
import { ToastService } from './services/toast.service';
import { AuthenticationInterceptor } from './services/interceptors/authentication-interceptor';
import { ComponentsModule } from './components/components.module';
import { AuthGuard } from './core/guard/auth.guard';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

export const API_INTERCEPTOR_PROVIDER: Provider = {
  provide: HTTP_INTERCEPTORS,
  useExisting: forwardRef(() => AuthenticationInterceptor),
  multi: true
};

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    ApiModule.forRoot({ rootUrl: environment.apiUrl }),
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot()
  ],
  declarations: [AppComponent],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000'
    }),
    // Storage v4 has to be opened before any get/set call; doing it here keeps
    // the synchronous storage API the rest of the app already relies on.
    provideAppInitializer(() => inject(Storage).create()),
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    ModalController,
    AuthenticationInterceptor,
    API_INTERCEPTOR_PROVIDER,
    AuthGuard,
    EventService,
    ApiService,
    ToastService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
